export const locale = {
  lang: 'en',
  data: {
    SELECTED: 'selected',
    DELETE: 'Sure you want to delete all selected items?'
  }
};
